export function isValidTimezone(value: unknown): value is string {
  if (typeof value !== "string" || !value.trim() || value !== value.trim() || /^[+-]/.test(value)) return false;
  try {
    new Intl.DateTimeFormat("en", { timeZone: value });
    return true;
  } catch (error) {
    if (error instanceof RangeError) return false;
    throw error;
  }
}

// IANA zones for the 50 U.S. states and Washington, D.C.; offsets alone do not
// distinguish U.S. locations or their daylight-saving rules.
const usTimezones = [
  "America/Adak",
  "America/Anchorage",
  "America/Boise",
  "America/Chicago",
  "America/Denver",
  "America/Detroit",
  "America/Indiana/Indianapolis",
  "America/Indiana/Knox",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Tell_City",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Juneau",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/Los_Angeles",
  "America/Menominee",
  "America/Metlakatla",
  "America/New_York",
  "America/Nome",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Phoenix",
  "America/Sitka",
  "America/Yakutat",
  "Pacific/Honolulu",
];

const canonicalUsTimezones = new Set(usTimezones.map(
  (timeZone) => new Intl.DateTimeFormat("en", { timeZone }).resolvedOptions().timeZone,
));

export function isUsTimezone(value: unknown): value is string {
  return isValidTimezone(value) && canonicalUsTimezones.has(
    new Intl.DateTimeFormat("en", { timeZone: value }).resolvedOptions().timeZone,
  );
}

export function timezoneOptions(current: string) {
  return [...new Set([...usTimezones, ...(isUsTimezone(current) ? [current] : [])])].sort();
}

export function defaultBusinessTimezone() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return isUsTimezone(timezone) ? timezone : "";
}
